import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import './SendText.css';
import { config } from "../../../../../../../config";
import { messages } from "../../../../../../../messages";
import axiosApi from './../../../../../../../core/interceptor/interceptor';
import _ from 'lodash';
import { AsyncPaginate } from 'react-select-async-paginate';
import DatePicker from 'react-datepicker';
import calendar from '../../../../../../../assets/calendar-icon.svg';
import moment from 'moment';
import CustomSelect from '../../../../../../../Util/CustomSelect/CustomSelect';
import { GENDER_MESSAGE, PLAYER_TYPE, YES_NOT_TYPE } from '../../../../../../../Util/helper';
function SendText(props) {
  const [textData, setTextData] = useState({
    body: '',
    recipients_id: 0
  });
  const [errors, setErrors] = useState({
    message: '',
    recepientUsers: '',
  });
  const [selectedUsers, setSelectedUsers] = useState([]);
  /***** getter and setter of seasons *****/
  const [selectedSeason, setSelectedSeason] = useState(null);
  const [selectedLeagues, setSelectedLeague] = useState([]);
  const [leagueListOption, setLeagueListOption] = useState([]);
  const [teamKey, setTeamKey] = useState(Math.floor(Math.random() * 90000) + 10000)
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectPlayerType, setSelectPlayerType] = useState('all');
  const [teamListOption, setTeamListOption] = useState([]);
  const [recipientKey, setRecipientKey] = useState(Math.floor(Math.random() * 90000) + 10000);
  const [smsTags, setSmsTags] = useState([
    { tag: '{first_name}', label: 'First Name' },
    { tag: '{last_name}', label: 'Last Name' },
  ])
  const [isSendNow, setIsSendNow] = useState(true);
  const [selectedDate, setSelectedDate] = useState();
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [sendToUnique, setSendToUnique] = useState(0);
  const [genderType, setGenderType] = useState('');
  useEffect(() => {
    if (props.location && props.location.state) {
      setTextData({ ...textData, body: props.location.state.body || '', });
      if (props.setArchieve) {
        props.setArchieve();
      }
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    handleValidation();
  }, [textData, isSendNow, selectedDate, selectedUsers])

  const handleFormChange = (event) => {
    setTextData(previousTextData => ({
      ...previousTextData,
      [event.target.name]: event.target.value,
    }));
  };

  const handleValidation = () => {
    let errorArr = {};
    let formIsValid = true;
    /***** name validation ******/
    if (!textData['body']) {
      formIsValid = false;
      errorArr["message"] = messages && messages.textMessage;
    }
    if (selectedUsers.length === 0) {
      formIsValid = false;
      errorArr["recepientUsers"] = messages && messages.selectRecipients
    }

    if (!isSendNow && !selectedDate) {
      formIsValid = false;
      errorArr["selectedDate"] = messages && messages.selectDateAndTime
    }
    setErrors(errorArr);
    return formIsValid;
  }

  const sendTextMessage = async () => {
    let allUserOnly = false;
    setFormSubmitted(true);
    if (selectedUsers?.length && !selectedTeams?.length && !selectedLeagues?.length && !selectedLeagues?.length) {
      const allSelected = selectedUsers.find(x => x.name === 'All');
      if (allSelected) {
        allUserOnly = true;
      }
    }

    let data = { ...textData };
    data.schedule_date_time_tz = moment(selectedDate ? selectedDate : new Date()).format('YYYY-MM-DD HH:mm:ss');
    data.is_send_now = isSendNow;
    if (!allUserOnly) {
      if (Array.isArray(selectedUsers)) {
        if (selectedUsers.some(user => user.id === 0)) {
          const users = await getUsersByLeague(0, '', true);
          data.recipients_id = _.uniqBy(users.map(user => user.id)).join();
        } else {
          data.recipients_id = selectedUsers.map(user => user.id).join();
        }
      }
    } else {
      data.all_user = true;
    }
    if (handleValidation()) {
      if (selectedSeason?.id) {
        data.season_id = selectedSeason?.id;
      }

      if (selectedLeagues?.length) {
        if (selectedLeagues.some(team => team.id === 0)) {
          data.leagues_id = _.uniqBy(leagueListOption.map(league => league.id)).join().replace('0,', '');
        } else {
          data.leagues_id = selectedLeagues.map(league => league.id).join();
        }
      }

      if (selectedTeams?.length) {
        if (selectedTeams.some(team => team.id === 0)) {
          data.teams_id = _.uniqBy(teamListOption.map(team => team.id)).join().replace('0,', '');
        } else {
          data.teams_id = selectedTeams.map(team => team.id).join();
        }
      }
      data.send_to_unique = sendToUnique;
      data.gender = genderType;
      axiosApi.post(`${config.apiUrl}/messages/text`, data)
        .then(() => {
          setTextData({
            body: '',
            recipients_id: ''
          });
          setFormSubmitted(false);
          setSelectedSeason(null);
          setSelectedLeague([]);
          setSelectedTeams([]);
          setSelectPlayerType('all');
          setRecipientKey(Math.floor(Math.random() * 90000) + 10000)
          setTeamKey(Math.floor(Math.random() * 90000) + 10000)
          setSelectedUsers([]);
          setIsSendNow(true);
          setSelectedDate(null);
          setSendToUnique(0);
          setGenderType('');
        })
        .catch((err) => {
          console.error(err);
        })
    }
  }

  const addTags = (x, keyName) => {
    const textarea = document.getElementById(keyName);
    const startPos = textarea.selectionStart;
    const endPos = textarea.selectionEnd;

    const updatedContent =
    textData.body.substring(0, startPos) + x.tag + textData.body.substring(endPos);
    setTextData((prev) =>  ({ ...prev, body: updatedContent }));

    const newPosition = startPos + x.tag.length;
    setTimeout(() => {
      textarea.setSelectionRange(newPosition, newPosition);
      textarea.focus();
    }, 0);
    textarea.focus();

  }

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      fontSize: "13px"
    }),
    option: (provided, state) => ({
      ...provided,
      cursor: "pointer"
    })
  }

  const getAllSeasons = async (page_, searchString) => {
    const seasons = await axiosApi.get(`${config.apiUrl}/seasons`, { params: { page: page_, search: searchString } });
    return seasons.data.data;
  }

  const getLeaguesBySeason = async (page_, searchString) => {
    const seasons = await axiosApi.get(`${config.apiUrl}/misc/leagues/${selectedSeason?.id || 0}`, { params: { page: page_, search_string: searchString, noLimit: (page_ === 0 ? true : false), sortColumn: 'id', } });
    return seasons.data.data;
  }

  const getTeamByLeague = async (page_, searchString) => {
    let leagueId = '';
    if (selectedLeagues.some(team => team.id === 0)) {
      const leagues = await getLeaguesBySeason(0, '');
      leagueId = _.uniqBy(leagues.map(league => league.id)).join().replace('0,', '');
    } else {
      leagueId = selectedLeagues.map(league => league.id).join();
    }

    let params = { page: page_, search: searchString, leagueId,  season: selectedSeason?.id, activeOnly: leagueId.length ? true: false, sortColumns: 'id' };
    if (page_ === 0) {
      params.noLimit = true;
    }
    const teams = await axiosApi.get(`${config.apiUrl}/misc/teams`, { params });
    return teams.data.data;
  }

  const getUsersByLeague = async (page_, searchString) => {
    let teamId = '';
    if (selectedTeams.some(team => team.id === 0)) {
      const teams = await getTeamByLeague(0, '');
      teamId = _.uniqBy(teams.map(team => team.id)).join();
      setTeamListOption(teams);
    } else {
      teamId = selectedTeams.map(team => team.id).join();
    }
    let leagueId = '';
    if (selectedLeagues.some(team => team.id === 0)) {
      leagueId = _.uniqBy(leagueListOption.map(league => league.id)).join();
    } else {
      leagueId = selectedLeagues.map(league => league.id).join();
    }
    let params = { page: page_, search: searchString, teamId, leagueId, selectPlayerType , season: selectedSeason?.id, is_valid_cell: true };
    if (page_ === 0) {
      params.noLimit = true;
    }
    if (genderType) {
      params.gender = genderType;
    }
    const users = await axiosApi.get(`${config.apiUrl}/seasons/all/user`, { params });
    return users.data.data;
  }

  const loadOptionsSeason = async (searchQuery, loadedOptions, { page }) => {
    const seasons = await getAllSeasons(page, searchQuery);
    return {
      options: seasons,
      hasMore: seasons.length === 20,
      additional: {
        page: page + 1,
      },
    };
  };

  const loadOptionsLeague = async (searchQuery, loadedOptions, { page }) => {
    const leagues = await getLeaguesBySeason(page, searchQuery);
    const leaguesLength = [...leagues].length;
    if (!loadedOptions?.length && leagues?.length) {
      leagues.unshift({ id: 0, name: 'All' });
    }
    setLeagueListOption([...loadedOptions, ...leagues])
    return {
      options: leagues,
      hasMore: leaguesLength === 20,
      additional: {
        page: page + 1,
      },
    };
  };

  const loadOptionsTeam = async (searchQuery, loadedOptions, { page }) => {
    const teams = await getTeamByLeague(page, searchQuery);
    const teamsLength = [...teams].length;
    if (!loadedOptions?.length && teams?.length) {
      teams.unshift({ id: 0, name: 'All' });
    }
    setTeamListOption([...loadedOptions, ...teams]);
    return {
      options: teams,
      hasMore: teamsLength === 20,
      additional: {
        page: page + 1,
      },
    };
  };

  const loadOptionsUser = async (searchQuery, loadedOptions, { page }) => {
    let users = await getUsersByLeague(page, searchQuery);
    if (users?.length) {
      users = users.map(x => ({...x, name: x.nameWithCell }));
    }
    const usersLength = [...users].length;
    if (!loadedOptions?.length && users?.length) {
      users.unshift({ id: 0, name: 'All' });
    }
    return {
      options: users,
      hasMore: usersLength === 20,
      additional: {
        page: page + 1,
      },
    };
  };

  const updateSmsTags = (newTag, remove = false) => {
    const foundTag = smsTags.find(tagObj => tagObj.tag === newTag.tag);
    if (!foundTag) {
      setSmsTags([...smsTags, newTag]);
    }
    if (remove) {
      const filteredTags = smsTags.filter(tagObj => tagObj.tag !== newTag.tag);
      setSmsTags(filteredTags);

    }
  }

  return <>
    <div className="inner-wrapper sendText-wrapper sendtext-block">
      <div className="flex-blk recipients-field">
        <label>Select Season</label>
        <AsyncPaginate
          className="multivalue-dropdown"
          value={selectedSeason}
          loadOptions={loadOptionsSeason}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          onChange={(option) => {
            setSelectedSeason(option);
            setSelectedLeague([]);
            setSelectedTeams([])
            setRecipientKey(Math.floor(Math.random() * 90000) + 10000)
            setTeamKey(Math.floor(Math.random() * 90000) + 10000)
            setSelectedUsers([]);
            updateSmsTags({ tag: '{season_name}', label: 'Season Name' });
          }}
          placeholder="Search Season"
          additional={{
            page: 1,
          }}
          debounceTimeout={1000}
          styles={customStyles}
          noOptionsMessage={() => "No Seasons Found."}
          isClearable={true}
        />
      </div>
      <div className="flex-blk recipients-field">
        <label>Select League</label>
        <AsyncPaginate
          className="multivalue-dropdown"
          key={selectedSeason?.id}
          value={selectedLeagues}
          loadOptions={loadOptionsLeague}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          onChange={(option) => {
            setSelectedTeams([])
            setSelectedUsers([]);
            if (option.length) {
              updateSmsTags({ tag: '{league_name}', label: 'League Name' });
              updateSmsTags({ tag: '{season_name}', label: 'Season Name' });
              if (option.some(league => league.id === 0)) {
                setSelectedLeague([{ id: 0, name: 'All' }]);
              } else {

                setSelectedLeague(option.filter(league => league.id));
              }
            } else {
              updateSmsTags({ tag: '{league_name}', label: 'League Name' }, true);
              updateSmsTags({ tag: '{season_name}', label: 'Season Name' }, true);
              setSelectedLeague([]);
            }
            setRecipientKey(Math.floor(Math.random() * 90000) + 10000)
            setTeamKey(Math.floor(Math.random() * 90000) + 10000);

          }}
          placeholder="Search League"
          additional={{
            page: 1,
          }}
          debounceTimeout={1000}
          styles={customStyles}
          isMulti={true}
          noOptionsMessage={() => "No Leagues Found."}
          isClearable={true}
        />
      </div>
      <div className="flex-blk recipients-field">
        <label>Select Team</label>
        <AsyncPaginate
          key={teamKey}
          isClearable={true}
          value={selectedTeams}
          loadOptions={loadOptionsTeam}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          onChange={(option) => {
            setSelectedUsers([]);
            setRecipientKey(Math.floor(Math.random() * 90000) + 10000)
            if (option.length) {
              updateSmsTags({ tag: '{league_name}', label: 'League Name' });
              updateSmsTags({ tag: '{season_name}', label: 'Season Name' });
              updateSmsTags({ tag: '{team_name}', label: 'Team Name' });
              if (option.some(team => team.id === 0)) {
                setSelectedTeams([{ id: 0, name: 'All' }]);
              } else {
                setSelectedTeams(option.filter(team => team.id));
              }
            } else {
              updateSmsTags({ tag: '{league_name}', label: 'League Name' }, true);
              updateSmsTags({ tag: '{season_name}', label: 'Season Name' }, true);
              updateSmsTags({ tag: '{team_name}', label: 'Team Name' }, true);
              setSelectedTeams([]);
            }

          }}
          placeholder="Search Team"
          additional={{
            page: 1,
          }}
          debounceTimeout={1000}
          isMulti={true}
          styles={customStyles}
          noOptionsMessage={() => "No Team Found."}
          className="multivalue-dropdown"
        />
      </div>
      <div className="flex-blk recipients-field play-type">
        <label>Select Player Type</label>
        <CustomSelect
            data={[
              {
                id: 'all',
                title: 'All Players'
              },
              {
                id: 'captain',
                title: 'Captain'
              },
            ]}
            placeholder={selectPlayerType ? PLAYER_TYPE[selectPlayerType] : ''}
            type={'text'}
            onSelect={(data) => {
              if (data) {
                setSelectedUsers([]);
                setRecipientKey(Math.floor(Math.random() * 90000) + 10000)
                setSelectPlayerType(data.id);
              }
            }}
            selector="title"
          />
      </div>
      <div className="flex-blk recipients-field play-type">
        <label>Choose Gender</label>
        <CustomSelect
            data={GENDER_MESSAGE}
            placeholder={genderType ? GENDER_MESSAGE.find((x) => genderType === x.value)?.title : 'Both'}
            type={'text'}
            onSelect={(data) => {
              if (data) {
                setGenderType(data.value);
                setRecipientKey(Math.floor(Math.random() * 90000) + 10000)
                setSelectedUsers([]);
              }
            }}
            selector="title"
          />
      </div>
      <div className="flex-blk recipients-field">
        <label>Select SMS Recipients</label>
        <AsyncPaginate
          className="multivalue-dropdown"
          key={recipientKey}
          value={selectedUsers}
          loadOptions={loadOptionsUser}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          onChange={(option, actionMeta) => {
            if (option.length) {
              if (option.some(user => user.id === 0)) {
                setSelectedUsers([{ id: 0, name: 'All' }]);
              } else {
                setSelectedUsers(option.filter(user => user.id));
              }
            } else {
              setSelectedUsers([]);
            }
          }}
          placeholder="Search User"
          additional={{
            page: 1,
          }}
          debounceTimeout={1000}
          styles={customStyles}
          isMulti={true}
          noOptionsMessage={() => "No Users Found."}
        />
        {Array.isArray(selectedUsers) && !selectedUsers.length && <span className="error">{formSubmitted && errors['recepientUsers']}</span>}
      </div>
      <div className="flex-blk recipients-field play-type">
        <label>Send to Unique Numbers</label>
        <CustomSelect
            data={YES_NOT_TYPE}
            placeholder={sendToUnique ? YES_NOT_TYPE.find((x) => sendToUnique === x.value)?.title : 'No'}
            type={'text'}
            onSelect={(data) => {
              if (data) {
                setSendToUnique(data.value)
              }
            }}
            selector="title"
          />
      </div>
      <div className="flex-blk message-field">
        <label htmlFor="email_subject">SMS</label>
        <textarea id='body' value={textData.body} name="body" rows="4" cols="50" onChange={(e) => handleFormChange(e)} />
        <div className="tags">
          {
            smsTags.map((x, i) => (
              <span key={i} onClick={() => { addTags(x, 'body') }}>{x.label}</span>
            ))
          }
        </div>
        {!(textData.body || '').trim() && < span className="error">{formSubmitted && errors['message']}</span>}
      </div>
      
      <div className="schedule-msg-outer">
        <h2>Schedule Message</h2>
        <div className="checkbox-outer">
          <div>
            <label>
              Send Now
              <input type="radio" checked={isSendNow} onChange={() => setIsSendNow(true)} />
            </label>
          </div>
          <div>
            <label>
              Schedule Date and Time
              <input type="radio" checked={!isSendNow} onChange={() => setIsSendNow(false)} />
            </label>
          </div>
        </div>
      </div>

      {!isSendNow && <div className='schedule-date-wrapper'>
        <div className="input-field">
          <label>Schedule Date<sup>*</sup></label>
          <div className="date-blk">
            <div className="calendar-blk">
              <img src={calendar} alt='calendar-icon' />
            </div>
            <DatePicker
              minDate={new Date()}
              selected={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              dateFormat="MMMM d, yyyy h:mm aa"
              showTimeSelect
              timeIntervals={5}
            />
            <span className="error">{formSubmitted && errors["selectedDate"]}</span>
          </div>
        </div>
      </div>}

      <button className="search-btn" onClick={() => sendTextMessage()}>Send SMS</button>
    </div>
  </>
}

export default withRouter(SendText);